export enum TransferMethod {
  ONLINE = 'ONLINE',
  PHONE = 'PHONE',
  BRANCH = 'BRANCH',
}
